import { useTranslation } from "react-i18next";
import { css } from "../../../../../styled-system/css";
import { VStack } from "../../../../../styled-system/jsx";
import DialogueCard from "../../../../modules/onboarding/components/DialogueCard";
import { useNavigate, createFileRoute } from "@tanstack/react-router";
import SkipToDashboardLink from "../../../../modules/onboarding/components/SkipToDashboardLink";
import { setCurrentUser } from "../../../../redux/reducers/userReducer";
import { useAppDispatch } from "../../../../redux/hooks";

const WalmartSellerType = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["onboarding"]);

  return (
    <VStack
      css={{
        alignItems: "flex-start",
        width: "100%",
        maxWidth: { base: "100%", lg: "66.666%" },
        marginX: "auto",
        paddingY: "xlarge",
        textAlign: "start",
      }}
      gap="large"
    >
      <VStack gap="xsmall" alignItems="flex-start" width="100%">
        <h2 className={css({ fontWeight: "600" })}>{t(($) => $.onboarding["Connect To Your Marketplaces"])}</h2>
        <p className={css({ fontSize: "xlarge" })}>
          {t(
            ($) =>
              $.onboarding[
                "Connect the channels you want to optimize. You will be able to add more after you onboard."
              ],
          )}
        </p>
        <h4 className={css({ fontWeight: "500" })}>{t(($) => $.onboarding["Select Your Seller Type"])}</h4>
      </VStack>

      <VStack gap="medium" width="100%">
        <DialogueCard
          title={t(($) => $.onboarding["First-Party (1P) Supplier"])}
          justify="center"
          onPress={() => {
            dispatch(setCurrentUser({ organization_type: "vendor" }));
            void navigate({ to: "/onboarding/v2/connect", search: { channel: "walmart", sellerType: "vendor" } });
          }}
        />
        <DialogueCard
          title={t(($) => $.onboarding["Third-Party (3P) Seller"])}
          justify="center"
          onPress={() => {
            dispatch(setCurrentUser({ organization_type: "seller" }));
            void navigate({ to: "/onboarding/v2/connect", search: { channel: "walmart", sellerType: "seller" } });
          }}
        />
        <SkipToDashboardLink />
      </VStack>
    </VStack>
  );
};

export const Route = createFileRoute("/_authenticated/onboarding/v2/sellertype")({
  component: WalmartSellerType,
});
